export default "__VITE_ASSET__DVF0_0vy__"